var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.url)?_c('img',{staticClass:"pin-preview",attrs:{"src":_vm.url,"width":_vm.size,"height":_vm.size,"alt":_vm.alt}}):_c('span',{staticClass:"pin-preview pin-preview--empty",style:({ width: (_vm.size + "px"), height: (_vm.size + "px") })})}
var staticRenderFns = []

export { render, staticRenderFns }